/**
 * Bugsnag deferred initialization + bootstrap queue drain.
 *
 * Expects:
 *   - window.Bugsnag (loaded via deferred CDN script)
 *   - window.__bugsnagBootstrap.events (populated by inline shim in theme.liquid)
 *   - window.theme.bugsnagApiKey (set in theme.liquid from theme settings)
 *
 * Failure modes:
 *   - Queued errors have weaker stack traces than natively-captured ones.
 *     Bugsnag.notify() from a replayed error lacks the original execution context,
 *     so grouping and source-map resolution may differ from live capture.
 *   - Errors thrown before the inline shim runs are still lost (same as any
 *     error monitoring that isn't baked into the HTML response itself).
 *   - If Bugsnag CDN fails to load, this script silently no-ops.
 */
(function () {
  'use strict';
  var apiKey = window.theme && window.theme.bugsnagApiKey;
  if (!apiKey || typeof window.Bugsnag === 'undefined') return;

  Bugsnag.start({
    apiKey: apiKey,
    collectUserIp: false,
    releaseStage: window.Shopify?.theme.role === 'main' && !window.Shopify?.designMode ? 'production' : 'development',
    metadata: {
      shop: {
        domain: window.Shopify?.shop,
        pageType: window.theme.pageType,
        country: document.documentElement.dataset.country,
      },
      theme: {
        name: window.Shopify?.theme.name,
        id: window.Shopify?.theme.id,
        role: window.Shopify?.theme.role,
      }
    }
  });

  // Drain the bootstrap queue
  var bootstrap = window.__bugsnagBootstrap;
  if (!bootstrap || !bootstrap.events || !bootstrap.events.length) return;

  var events = bootstrap.events;
  // Clear immediately to prevent double-drain if this script somehow runs twice
  bootstrap.events = [];

  for (var i = 0; i < events.length; i++) {
    var entry = events[i];

    if (entry.type === 'error' && entry.error) {
      Bugsnag.notify(entry.error, function (event) {
        event.context = 'pre-init bootstrap queue';
        event.addMetadata('bootstrap', {
          filename: entry.filename,
          lineno: entry.lineno,
          colno: entry.colno
        });
      });
    } else if (entry.type === 'unhandledrejection' && entry.reason) {
      var err = entry.reason instanceof Error
        ? entry.reason
        : new Error(String(entry.reason));
      Bugsnag.notify(err, function (event) {
        event.context = 'pre-init bootstrap queue (unhandledrejection)';
      });
    }
  }
})();
